import Vue from 'vue'
Vue.directive('drag', {
  inserted: function (el) {
    const parentEl = el.parentNode
    el.onmousedown = function (ev) {
      var disX = parentEl.offsetWidth - (ev.clientX - parentEl.offsetLeft)
      var disY = ev.clientY - parentEl.offsetTop
      const screenWidth = document.body.clientWidth // body当前宽度
      const screenHeight = document.documentElement.clientHeight // 可见区域高度(应为body高度，可某些环境下无法获取)

      const dragDomWidth = parentEl.offsetWidth // 对话框宽度
      const dragDomheight = parentEl.offsetHeight // 对话框高度
      const maxDragDomLeft = screenWidth - dragDomWidth
      const maxDragDomTop = screenHeight - dragDomheight
      let zIndex = Number(localStorage.getItem('dialogZIndex'))
      if (zIndex < parentEl.style.zIndex) {
        zIndex = parentEl.style.zIndex * 1 + 1
      } else {
        zIndex = zIndex + 1
      }
      parentEl.style.zIndex = zIndex
      localStorage.setItem('dialogZIndex', JSON.stringify(zIndex))
      document.onmousemove = function (e) {
        parentEl.style.cursor = 'move'
        // 通过事件委托，计算移动的距离
        let right = screenWidth - e.clientX - disX
        let top = e.clientY - disY

        if (right < 0) {
          right = 0
        }
        if (top < 0) {
          top = 0
        }
        if (right > maxDragDomLeft) {
          right = maxDragDomLeft
        }
        if (top > maxDragDomTop) {
          top = maxDragDomTop
        }
        // 移动当前元素
        parentEl.style.cssText += `;right:${right}px;top:${top}px;`
      }
      document.onmouseup = function () {
        parentEl.style.cursor = 'default'
        document.onmousemove = null
        document.onmouseup = null
      }
    }
  }
})
